/* Choose Your Forever Pan — quiz engine
   Ironclad Pan Co. Reads product data from window.FPQ_PRODUCTS (Liquid data island)
   and settings from window.FPQ_SETTINGS. All copy lives in COPY below.
   Spec: campaigns/forever-pan-quiz/02-quiz-design.md (v1.5) + 03-shopify-build-brief.md */
(function () {
  'use strict';
  var P = window.FPQ_PRODUCTS || {};
  var S = window.FPQ_SETTINGS || {};
  var root = document.getElementById('fpq-root');
  if (!root) return;

  /* ---------------- COPY ---------------- */
  var COPY = {
    intro: {
      h: 'Three generations start with one pan. Find yours.',
      p: 'Eight questions. Two minutes. One pan for life.',
      btn: 'Start',
      foot: 'Hand-poured from recycled iron. Guaranteed for three generations.'
    },
    questions: [
      { id: 'chef', q: 'Whose kitchen feels most like yours?', opts: [
        { l: "Lennox Hastie's. No gas line, no shortcuts. Just fire.", v: 'lennox' },
        { l: "Al Brown's. Informal, generous, feed whoever turns up.", v: 'al' },
        { l: "Peter Gordon's. Precise, curious, every cuisine on one shelf.", v: 'peter' },
        { l: "My nana's. Food that gets handed down with the pan.", v: 'heritage' } ] },
      { id: 'meal', q: "What's the meal you want to be known for?", opts: [
        { l: 'A roast that ends with everyone quiet for a minute', v: 'roast' },
        { l: 'Steak with a crust you can hear', v: 'steak' },
        { l: 'Bread and slow braises on a winter afternoon', v: 'slow' },
        { l: 'The long table. Everyone fed, nobody counting.', v: 'crowd' } ] },
      { id: 'use_case', q: 'What are you cooking on?', opts: [
        { l: 'Gas', v: 'gas' }, { l: 'Induction', v: 'induction' }, { l: 'Electric', v: 'electric' },
        { l: 'Fire, BBQ, or camping', v: 'live_fire' }, { l: 'Pizza oven', v: 'pizza_oven' } ] },
      { id: 'household', q: 'How many forks appear when dinner is ready?', opts: [
        { l: 'One', v: '1-2', raw: 'one' },
        { l: 'Two', v: '1-2', raw: 'two' },
        { l: 'Three or four', v: '3-4', raw: 'three_four' },
        { l: "It's like an angry mob", v: '5plus', raw: 'mob' } ] },
      { id: 'care', q: 'Seasoning a pan: ritual or homework?', opts: [
        { l: 'Ritual. I want the iron and the routine.', v: 'seasoned' },
        { l: 'Homework. Give me the low-maintenance one.', v: 'enamel' },
        { l: 'Whatever gives me the best result', v: 'unsure' } ] },
      { id: 'drawer', q: "What's in the pan drawer right now?", opts: [
        { l: 'A nonstick on its last legs. Again.', v: 'nonstick_cycle' },
        { l: "Someone's old cast iron I don't quite trust yet", v: 'inherited' },
        { l: 'Stainless that sticks', v: 'stainless' },
        { l: 'A bit of everything, none of it loved', v: 'mixed' } ] },
      { id: 'sting', q: 'Be honest. When a pan gives up, what gets you?', opts: [
        { l: 'Wondering where the coating went. Because I know.', v: 'coating' },
        { l: 'Buying the same pan twice. Then a third time.', v: 'rebuy' },
        { l: 'Dinner sticking on the night it mattered', v: 'stick' },
        { l: 'Another pan in the landfill', v: 'waste' } ] },
      { id: 'priority', q: 'What would make this pan yours?', opts: [
        { l: 'It outlasts me, and my kids argue over it', v: 'heirloom' },
        { l: 'It looks right going oven to table', v: 'table' },
        { l: "It fits the whole family's dinner in one go", v: 'capacity' },
        { l: 'It handles proper fire', v: 'fire' } ] },
      { id: 'colour', q: 'Which colour is calling?', enamelOnly: true, swatch: true, opts: [
        { l: 'Salt Stone', v: 'salt', hex: '#DFD8C8' },
        { l: 'Olive Leaf', v: 'olive', hex: '#6C7150' },
        { l: 'Antique Black', v: 'black', hex: '#26241F' } ] }
    ],
    inter: { h: 'Matching you to your pan.', lines: ['Reading your stove...', 'Weighing the iron...', 'Checking the drawer...'] },
    archetypes: {
      purist: { name: 'The Purist', head: 'Small pan. Serious heat. Yours.' },
      sunday_roaster: { name: 'The Sunday Roaster', head: "The pan that started it all. Now it's yours." },
      long_table: { name: 'The Long Table', head: 'Big enough for everyone. Good enough to pass down.' },
      host: { name: 'The Host', head: 'Cast iron. None of the homework.' },
      slow_sunday: { name: 'The Slow Sunday', head: 'Slow Sundays live here.' },
      fire_cook: { name: 'The Fire Cook', head: 'Four tools in one pour.' }
    },
    sting: {
      coating: 'Somewhere between the first pancake and today, the coating thinned. You know where it went. Coated pans are built to a price and a lifespan, and both are short. Iron has no coating to lose.',
      rebuy: 'That pan was $60. So was the one before it, and the one before that. The industry calls it a replacement cycle. We call it the same pan, three times. This one you buy once.',
      stick: 'A thin pan has one temperature: too hot in the middle, cold at the edge. Heat retention is a function of mass. 4mm walls on a 5mm base hold the sear a thin pan drops.',
      waste: 'Every coated pan ends the same way, and it is not in a will. Ours start as recycled iron and end as an argument between your kids. That is the whole idea.'
    },
    chef: {
      lennox: { q: 'Timeless quality and craftsmanship', c: 'Chef Lennox Hastie. Co-owner, Ironclad.' },
      al: { q: 'The best cast iron in the business', c: 'Chef Al Brown. Co-owner, Ironclad.' },
      peter: { q: 'Beautifully made. Gorgeous to cook with.', c: 'Chef Peter Gordon. Co-owner, Ironclad.' },
      heritage: { q: 'It is owned by chefs. It is owned by 250 founding customers who helped build this company. And it is backed by a guarantee cast into the iron itself.', c: 'Ironclad Co.' }
    },
    reviews: {
      seasoned: [
        { q: "I have had a NZ made pan for 40 years and it was my mother's before that... My Legacy Pan has a look and feel of real quality about it and I'm sure my great grandchildren will be using it one day.", c: 'Ivan H. Verified buyer' },
        { q: 'Beautiful to look at and incredible to cook with. The crust on steak is perfect and I have been surprised by the natural non stick quality.', c: 'Ken M. Verified buyer' }
      ]
    },
    specs: {
      seasoned: ['Hand-poured from recycled iron, hand seasoned, ready to use', '4mm walls on a 5mm base. Heat that holds.', 'No PFAS, PFOA, PTFE', 'Gas, induction, electric, BBQ, oven, open fire'],
      enamel: ['Cast iron under a natural glass satin finish', 'No seasoning. Ever. Soap is fine.', 'Oven safe to 300°C', 'Gas, induction, electric and oven'],
      dutch: ['4.5L of slow, even cast iron heat', 'Natural glass satin finish, no seasoning', 'Oven safe to 300°C, lid on', 'Bread, braises, roasts, one pot'],
      fireoven: ['Four precision elements interlock into six pieces of cookware', 'A bread oven. A slow roaster. A smoker. A steamer. A Dutch oven. A skillet.', 'Designed with Lennox Hastie. Handmade from pure recycled iron.', '1,500 numbered. Never remade.']
    },
    /* Objection copy lifted verbatim from the live PDP FAQs (owner ruling 2026-08-04) */
    objections: {
      seasoned: [
        { q: 'Do I have to season it?', a: 'No. It comes triple seasoned and ready to cook. Over time, it will darken and blacken as the natural oils build up a coating. A light oil after cleaning helps, but that’s it.' },
        { q: 'Is it going to be a pain to clean?', a: 'No. It is easy. Hot water. Quick scrub. Dry it. Oil it. That’s it. No soaking. No drip drying. No fuss.' },
        { q: 'Is it too heavy for everyday use?', a: 'It’s designed with varying thicknesses to reduce weight and improve balance. Thicker where you need it. Thinner where you don’t. The Lil Legacy comes in under 1.8kg, about the weight of a half full kettle. The Legacy comes in under 2.8kg, about the weight of a full kettle.' } ],
      enamel: [
        { q: 'Is the enamel non-stick?', a: 'Yes. The satin enamel surface is naturally non-stick and will improve with use. For the first few meals, cook oil-rich dishes.' },
        { q: 'Do I need to season enamel pans?', a: 'No. Unlike pure cast iron, Ironclad enamel pans do not need seasoning. Just wash, dry, and cook. Easy.' },
        { q: 'Can I use soap?', a: 'Go nuts. Soap is completely fine on enamel cast iron. That is one of the advantages of the finish. Soap friendly and soak friendly.' } ],
      fireoven: [
        { q: 'When does it arrive?', a: 'Pre-orders are open now for September delivery.' },
        { q: 'Why numbered?', a: 'Because there are 1,500 and there will never be more. When a design sells out it is gone for good.' } ]
    },
    solution: {
      seasoned: 'Hand-poured from recycled iron. 4mm walls, 5mm base. Hand polished to our Antique Finish™. No PFAS, PFOA, PTFE.',
      enamel: 'Hand-poured from recycled iron. 4mm walls, 5mm base. Finished in a natural glass satin enamel. No PFAS, PFOA, PTFE.'
    },
    close: 'Cook on it for 30 days. If it is not right, send it back and we refund you, return shipping covered. A $60 nonstick every two years is $900 over thirty. This is one pour.',
    unlock: {
      btn: 'Get free shipping',
      openP: 'Join the Ironclub and NZ shipping on this order is on us.',
      submit: 'Unlock',
      fine: 'No spam. One-click unsubscribe.',
      doneBtn: 'Code applied',
      doneP: 'Applied to your checkout.'
    },
    signoff: 'Make some memories.'
  };

  /* ---------------- ROUTING ---------------- */
  function resolve(a) {
    var enamelLean = a.care === 'enamel' || (a.care === 'unsure' && (a.priority === 'table' || a.chef === 'peter'));
    var path = enamelLean ? 'enamel' : 'seasoned';
    if (a.use_case === 'live_fire' && a.priority === 'fire') {
      if (P.fireoven && P.fireoven.available) return { arch: 'fire_cook', family: 'fireoven', size: null };
      return { arch: 'fire_cook', family: 'seasoned', size: 36, soldout: true };
    }
    if (a.meal === 'slow') {
      if (path === 'enamel') return { arch: 'slow_sunday', family: 'dutch', size: null };
      return { arch: 'slow_sunday', family: 'seasoned', size: 28 };
    }
    /* Capacity only upsizes to the 36 when the household supports it (owner fix 2026-08-04:
       "cooking for two + capacity" ideal outcome is the 28, not the Grande). */
    if (a.household === '5plus' || a.meal === 'crowd' || (a.priority === 'capacity' && a.household !== '1-2')) {
      return { arch: 'long_table', family: path, size: 36 };
    }
    if (a.priority === 'capacity') {
      return path === 'enamel' ? { arch: 'host', family: 'enamel', size: 28 } : { arch: 'sunday_roaster', family: 'seasoned', size: 28 };
    }
    if (path === 'enamel') {
      var small = a.household === '1-2' && a.meal !== 'steak';
      return { arch: 'host', family: 'enamel', size: small ? 20 : 28 };
    }
    if (a.household === '1-2' && a.meal !== 'steak') return { arch: 'purist', family: 'seasoned', size: 20 };
    return { arch: 'sunday_roaster', family: 'seasoned', size: 28 };
  }

  /* ------------- PRODUCT LOOKUP ------------- */
  function prod(key) { return P[key] || null; }
  function panFor(family, size, colour) {
    if (family === 'seasoned') return prod('s' + size);
    if (family === 'enamel') return prod('e' + size + '_' + colour);
    if (family === 'dutch') return prod('dutch_' + colour);
    if (family === 'fireoven') return prod('fireoven');
    return null;
  }
  /* Bundles per family (owner spec: seasoned = Duo + Nesting; enamel = two-pan bundle + Nesting; dutch/fireoven = none) */
  function bundlesFor(st) {
    if (st.family === 'seasoned') {
      return [
        { key: 'duo', p: prod('duo'), sub: '28cm + 20cm seasoned pans', components: ['s28', 's20'] },
        { key: 'nesting', p: prod('nesting'), sub: '20cm + 28cm + 36cm seasoned pans', components: ['s20', 's28', 's36'] }
      ].filter(function (b) { return b.p && b.p.available; });
    }
    if (st.family === 'enamel') {
      var out = [];
      /* Two-pan upgrade: 20/28 results get the enamel Legacy Bundle 28+20; 36 gets the Lil Grande 20+36 (owner spec 2026-08-04) */
      if (st.size === 36) {
        var lg = prod('enamel_lilgrande');
        if (lg && lg.available) {
          var lgv = variantByTitle(lg, st.colour);
          if (lgv && lgv.available) out.push({ key: 'enamel_lilgrande', p: lg, variant: lgv, sub: '20cm + 36cm satin enamel', components: ['e20_' + st.colour, 'e36_' + st.colour] });
        }
      } else {
        var ed = prod('enamel_duo');
        if (ed && ed.available) {
          var edv = variantByTitle(ed, st.colour);
          if (edv && edv.available) out.push({ key: 'enamel_duo', p: ed, variant: edv, sub: '28cm + 20cm satin enamel', components: ['e28_' + st.colour, 'e20_' + st.colour] });
        }
      }
      var b = prod('enamel_nesting');
      if (b) {
        var v = variantByTitle(b, st.colour);
        if (v && v.available) out.push({ key: 'enamel_nesting', p: b, variant: v, sub: '20cm + 28cm + 36cm satin enamel, ' + colourName(st.colour), components: ['e20_' + st.colour, 'e28_' + st.colour, 'e36_' + st.colour] });
      }
      return out;
    }
    return [];
  }
  /* Add-ons (owner rules: no care kits on enamel; no snugs on grande/dutch; sold-out products never appear; unsure = zero).
     Bundle-aware (owner 2026-08-04): any bundle containing the 20cm + 28cm pair swaps the single lid for the 20+28cm Lid Duo. */
  function addonsFor(st, mode) {
    var out = [];
    function push(key, variantTitleMatch, drawer) {
      var p = prod(key); if (!p) return;
      var v = variantTitleMatch ? variantByTitle(p, variantTitleMatch) : (p.variants[0] || null);
      if (!v || !v.available) return;
      out.push({ key: key + (variantTitleMatch || ''), p: p, v: v, drawer: drawer });
    }
    mode = mode || 'pan';
    var pairBundle = mode === 'nesting' || mode === 'duo' || mode === 'enamel_nesting' || mode === 'enamel_duo';
    if (st.family === 'seasoned') {
      push('balm', null, 'Lemon myrtle conditioning balm. A one-minute ritual that keeps seasoned iron slick and black.');
      if (pairBundle) {
        push('lidduo', mode.indexOf('enamel') === 0 ? st.colour : 'black', 'The 20cm and 28cm satin enamel lid duo. Two lids, both your pans covered.');
      } else {
        push('servinglid', String(st.size), 'Carbonised bamboo lid, sized to your pan. Stove to table, keeps the heat in.');
      }
      push('scrubber', null, 'The bamboo pot scrubber. Cleans seasoned iron without stripping the season.');
    } else if (st.family === 'enamel') {
      if (pairBundle) {
        push('lidduo', st.colour, 'The 20cm and 28cm satin enamel lid duo in ' + colourName(st.colour) + '. Two lids, both your pans covered.');
      } else if (st.size === 20 || st.size === 28) {
        push(st.size === 20 ? 'elid20' : 'elid28', st.colour, 'Satin enamel lid in ' + colourName(st.colour) + '. Turns your pan into a small oven.');
      }
    }
    /* enamel 36cm single, Old Dutch, Fire Oven: zero add-ons by owner instruction */
    return out;
  }
  function variantByTitle(p, needle) {
    needle = String(needle).toLowerCase();
    var map = { salt: 'salt', olive: 'olive', black: 'black', '20': '20', '28': '28', '36': '36' };
    var n = map[needle] || needle;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].title.toLowerCase().indexOf(n) !== -1) return p.variants[i];
    }
    return p.variants[0] || null;
  }
  function colourName(c) { return c === 'salt' ? 'Salt Stone' : c === 'olive' ? 'Olive Leaf' : 'Antique Black'; }
  function money(n) { return '$' + Math.round(n) + ' NZD'; }

  /* ---------------- STATE ---------------- */
  var state = { step: -1, answers: {}, raw: {}, res: null, mode: 'pan', colour: 'salt', addons: {}, unlocked: false };
  try { var saved = sessionStorage.getItem('fpq_v1'); if (saved) { var s0 = JSON.parse(saved); if (s0 && s0.answers) { state.answers = s0.answers; state.raw = s0.raw || {}; } } } catch (e) {}
  function persist() { try { sessionStorage.setItem('fpq_v1', JSON.stringify({ answers: state.answers, raw: state.raw })); } catch (e) {} }

  /* ---------------- EVENTS ---------------- */
  function track(name, props) {
    try { if (window.posthog && window.posthog.capture) window.posthog.capture(name, props || {}); } catch (e) {}
  }
  function fb(evt, props, custom) {
    try { if (window.fbq) { custom ? window.fbq('trackCustom', evt, props || {}) : window.fbq('track', evt, props || {}); } } catch (e) {}
  }
  function klaviyoProps() {
    var a = state.answers, r = state.res;
    return {
      quiz_result: resultKey(), quiz_archetype: r ? r.arch : null, quiz_chef: a.chef, quiz_meal: a.meal,
      use_case: a.use_case, quiz_household: a.household, quiz_care: a.care, quiz_drawer: a.drawer,
      quiz_sting: a.sting, quiz_priority: a.priority, quiz_colour: state.colour ? colourName(state.colour) : null,
      quiz_completed_at: new Date().toISOString(), source: 'foreverpan_mofu'
    };
  }
  function klaviyoIdentifyAndTrack(email) {
    var props = klaviyoProps(); props.$email = email;
    try {
      var q = window._learnq = window._learnq || [];
      q.push(['identify', props]);
      q.push(['track', 'Completed Forever Pan Quiz', klaviyoProps()]);
    } catch (e) {}
    /* Modern client API subscription (records Ironclub consent) when company id is configured */
    if (S.klaviyoCompanyId && S.klaviyoListId) {
      try {
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(S.klaviyoCompanyId), {
          method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({ data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: email, properties: klaviyoProps() } } }, custom_source: 'Forever Pan Quiz' }, relationships: { list: { data: { type: 'list', id: S.klaviyoListId } } } } })
        });
      } catch (e) {}
    }
  }
  function resultKey() {
    var r = state.res; if (!r) return null;
    if (r.family === 'fireoven') return 'lennox_fos';
    if (r.family === 'dutch') return 'old_dutch';
    return (r.family === 'enamel' ? 'enamel_' : '') + 'pan_' + r.size;
  }

  /* ---------------- RENDER: SHARED ---------------- */
  function el(html) { var d = document.createElement('div'); d.innerHTML = html.trim(); return d.firstChild; }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  var live = el('<div class="fpq__sr" aria-live="polite"></div>'); root.appendChild(live);
  function announce(t) { live.textContent = t; }
  var visibleQs = function () { return COPY.questions.filter(function (q) { return !q.enamelOnly || isEnamelPath(); }); };
  function isEnamelPath() {
    var a = state.answers;
    return a.care === 'enamel' || (a.care === 'unsure' && (a.priority === 'table' || a.chef === 'peter'));
  }

  function render() {
    var app = root.querySelector('.fpq__app') || root.appendChild(el('<div class="fpq__app"></div>'));
    var qs = visibleQs();
    if (state.step === -1) return renderIntro(app);
    if (state.step >= 0 && state.step < qs.length) return renderQuestion(app, qs[state.step], qs.length);
    if (state.step === qs.length) return renderInterstitial(app);
    return renderResults(app);
  }

  function renderIntro(app) {
    app.innerHTML = '<div class="fpq__wrap fpq__intro">' +
      '<p class="fpq__eyebrow">Choose your forever pan</p>' +
      '<h1>' + COPY.intro.h + '</h1><p>' + COPY.intro.p + '</p>' +
      '<button class="fpq__btn" data-start>' + COPY.intro.btn + '</button>' +
      '<p class="fpq__foot">' + COPY.intro.foot + '</p></div>';
    app.querySelector('[data-start]').addEventListener('click', function () { state.step = 0; track('foreverpan_started'); render(); });
  }

  function renderQuestion(app, q, total) {
    var opts = q.swatch
      ? '<div class="fpq__opts fpq__swatches" role="group">' + q.opts.map(function (o, i) {
          return '<button class="fpq__opt fpq__swatch" data-i="' + i + '"><span class="fpq__swatch-chip" style="background:' + o.hex + '"></span><span class="fpq__mono">' + esc(o.l) + '</span></button>';
        }).join('') + '</div>'
      : '<div class="fpq__opts" role="group">' + q.opts.map(function (o, i) {
          return '<button class="fpq__opt" data-i="' + i + '">' + esc(o.l) + '</button>';
        }).join('') + '</div>';
    app.innerHTML = '<div class="fpq__wrap">' +
      '<div class="fpq__head"><button class="fpq__back" data-back' + (state.step === 0 ? ' hidden' : '') + '>&larr; Back</button>' +
      '<span class="fpq__count">' + (state.step + 1) + ' OF ' + total + '</span></div>' +
      '<div class="fpq__bar" role="progressbar" aria-valuemin="0" aria-valuemax="' + total + '" aria-valuenow="' + (state.step + 1) + '"><div class="fpq__bar-fill" style="width:' + ((state.step + 1) / total * 100) + '%"></div></div>' +
      '<h2 class="fpq__q">' + esc(q.q) + '</h2>' + opts + '</div>';
    announce('Question ' + (state.step + 1) + ' of ' + total + '. ' + q.q);
    var back = app.querySelector('[data-back]');
    if (back) back.addEventListener('click', function () { state.step = Math.max(0, state.step - 1); render(); });
    app.querySelectorAll('.fpq__opt').forEach(function (b) {
      b.addEventListener('click', function () {
        var o = q.opts[+b.getAttribute('data-i')];
        b.classList.add('is-selected');
        state.answers[q.id] = o.v; if (o.raw) state.raw[q.id] = o.raw;
        if (q.id === 'colour') state.colour = o.v;
        persist();
        track('foreverpan_q_answered', { q: q.id, value: o.v, step_index: state.step });
        setTimeout(function () { state.step += 1; render(); }, 250);
      });
    });
    app.querySelector('h2').setAttribute('tabindex', '-1'); app.querySelector('h2').focus({ preventScroll: true });
  }

  function renderInterstitial(app) {
    app.innerHTML = '<div class="fpq__wrap fpq__inter"><h2>' + COPY.inter.h + '</h2><p data-line></p><span class="fpq__inter-line"></span></div>';
    var i = 0, lineEl = app.querySelector('[data-line]');
    var iv = setInterval(function () { lineEl.textContent = COPY.inter.lines[i % 3]; i++; }, 700);
    lineEl.textContent = COPY.inter.lines[0];
    var done = function () { clearInterval(iv); state.res = resolve(state.answers); state.step += 1; render(); };
    var t = setTimeout(done, 2500);
    setTimeout(function () { app.addEventListener('click', function () { clearTimeout(t); done(); }, { once: true }); }, 1000);
  }

  /* ---------------- RENDER: RESULTS ---------------- */
  function currentSelection() {
    var st = { family: state.res.family, size: state.res.size, colour: state.colour, arch: state.res.arch };
    var bundles = bundlesFor(st);
    var sel = { st: st, bundles: bundles, bundle: null, pan: panFor(st.family, st.size, st.colour) };
    if (state.mode !== 'pan') { sel.bundle = bundles.filter(function (b) { return b.key === state.mode; })[0] || null; }
    return sel;
  }
  function priceOf(sel) {
    var items = [], total = 0;
    if (sel.bundle) {
      var v = sel.bundle.variant || sel.bundle.p.variants[0];
      items.push({ id: v.id, title: sel.bundle.p.title }); total += v.price;
    } else if (sel.pan) {
      var pv = sel.pan.variants[0]; items.push({ id: pv.id, title: sel.pan.title }); total += pv.price;
    }
    addonsFor(sel.st, state.mode).forEach(function (a) {
      if (state.addons[a.key]) { items.push({ id: a.v.id, title: a.p.title }); total += a.v.price; }
    });
    return { items: items, total: total };
  }
  function savings(b) {
    var rrp = 0;
    b.components.forEach(function (k) { var p = prod(k); if (p && p.variants[0]) rrp += p.variants[0].price; });
    var bp = (b.variant || b.p.variants[0]).price;
    return rrp > bp ? rrp - bp : 0;
  }
  function permalink(sel) {
    var pr = priceOf(sel);
    var parts = pr.items.map(function (i) { return i.id + ':1'; }).join(',');
    var qs = [];
    if (state.unlocked && state.email) qs.push('checkout[email]=' + encodeURIComponent(state.email));
    if (state.unlocked) qs.push('discount=' + encodeURIComponent(S.discountCode || 'QUIZSHIP'));
    qs.push('attributes[quiz_result]=' + encodeURIComponent(resultKey()));
    qs.push('attributes[quiz_archetype]=' + encodeURIComponent(state.res.arch));
    var add = Object.keys(state.addons).filter(function (k) { return state.addons[k]; });
    if (add.length) qs.push('attributes[quiz_addons]=' + encodeURIComponent(add.join(',')));
    return '/cart/' + parts + '?' + qs.join('&');
  }

  function renderResults(app) {
    var a = state.answers, r = state.res;
    if (state.colour == null || !a.colour) state.colour = state.colour || 'salt';
    var sel = currentSelection();
    var arch = COPY.archetypes[r.arch];
    var fam = r.family === 'fireoven' ? 'fireoven' : (r.family === 'dutch' ? 'dutch' : r.family);
    var pan = sel.bundle ? sel.bundle.p : sel.pan;
    if (!pan) { app.innerHTML = '<div class="fpq__wrap"><p>Product configuration missing. Assign products in the theme editor (see INSTALL).</p></div>'; return; }
    var pr = priceOf(sel);
    var showPrice = true; /* owner ruling 2026-08-04: Fire Oven shows price + ATC on the quiz too */
    var playback = playbackLine(a);
    var objKey = fam === 'fireoven' ? 'fireoven' : (fam === 'seasoned' ? 'seasoned' : 'enamel');

    var html = '<div class="fpq__wrap">' +
      '<p class="fpq__eyebrow">Your result</p>' +
      '<h1 class="fpq__reveal">You’re ' + articleFor(arch.name) + ' ' + arch.name.replace('The ', '') + '.</h1>' +
      '<p class="fpq__playback">' + esc(playback) + '</p>' +
      '<div class="fpq__badges"><span class="fpq__badge">Ready to ship</span><span class="fpq__badge fpq__badge--plain">Poured from recycled iron</span></div>' +
      (pan.img ? '<img class="fpq__hero" src="' + esc(pan.img) + '" alt="' + esc(pan.title) + '">' : '') +
      '<h2 class="fpq__title">' + esc(pan.title) + '</h2>' +
      (showPrice ? '<p class="fpq__price" data-price>' + money(pr.total) + '</p>' : '') +
      '<ul class="fpq__specs">' + COPY.specs[fam].map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('') + '</ul>';

    /* Size pills (seasoned + enamel pans only) */
    if (fam === 'seasoned' || fam === 'enamel') {
      html += '<p class="fpq__label">Size</p><div class="fpq__pills" role="group" aria-label="Size">' +
        [20, 28, 36].map(function (s) {
          var p = panFor(fam, s, state.colour); var ok = p && p.available;
          return '<button class="fpq__pill' + (s === r.size && state.mode === 'pan' ? ' is-selected' : '') + '" data-size="' + s + '"' + (ok ? '' : ' disabled') + (state.mode !== 'pan' ? ' disabled' : '') + '>' + s + 'cm</button>';
        }).join('') + '</div>' +
        '<p class="fpq__hint">' + sizeHint(a, r) + '</p>';
    }

    /* Upgrade & Save */
    if (sel.bundles.length) {
      html += '<p class="fpq__label">Upgrade &amp; save</p><div class="fpq__bundles" role="group" aria-label="Upgrade and save">';
      html += bundleCard({ key: 'pan', name: 'This pan only', sub: null, save: 0, img: sel.pan ? sel.pan.img : null }, state.mode === 'pan');
      sel.bundles.forEach(function (b) {
        html += bundleCard({ key: b.key, name: b.p.title, sub: b.sub, save: savings(b), img: b.p.img }, state.mode === b.key);
      });
      html += '</div>';
    }

    /* Colour swatches */
    if (fam === 'enamel' || fam === 'dutch') {
      html += '<p class="fpq__label">Colour<small>' + colourName(state.colour) + '</small></p><div class="fpq__colours" role="group" aria-label="Colour">' +
        ['salt', 'olive', 'black'].map(function (c) {
          var p = fam === 'dutch' ? prod('dutch_' + c) : panFor('enamel', r.size, c); var ok = p && p.available;
          var hex = c === 'salt' ? '#DFD8C8' : c === 'olive' ? '#6C7150' : '#26241F';
          return '<button class="fpq__colour' + (c === state.colour ? ' is-selected' : '') + '" data-colour="' + c + '"' + (ok ? '' : ' disabled') + '><span class="fpq__colour-chip" style="background:' + hex + '"></span>' + colourName(c).split(' ')[0] + '</button>';
        }).join('') + '</div>';
    }

    /* Add-ons */
    var adds = addonsFor(sel.st, state.mode);
    if (adds.length) {
      html += '<p class="fpq__label">Add-ons</p><div class="fpq__addons">' + adds.map(function (ad) {
        var checked = !!state.addons[ad.key];
        return '<div class="fpq__addon' + '" data-addon="' + esc(ad.key) + '">' +
          '<label class="fpq__addon-row"><input type="checkbox"' + (checked ? ' checked' : '') + '>' +
          '<span class="fpq__addon-name">' + esc(ad.p.title) + '</span>' +
          '<span class="fpq__addon-price">+' + money(ad.v.price) + '</span>' +
          '<button type="button" class="fpq__addon-toggle" aria-expanded="false" aria-label="More about ' + esc(ad.p.title) + '"><svg viewBox="0 0 16 16" fill="none"><path d="M3 6l5 5 5-5" stroke="currentColor" stroke-width="1.5"/></svg></button></label>' +
          '<div class="fpq__addon-drawer">' + esc(ad.drawer) + '</div></div>';
      }).join('') + '</div>';
    }

    /* Buy row: ATC + GET FREE SHIPPING inline (Fire Oven included, owner ruling 2026-08-04) */
    html += '<div class="fpq__buyrow">' +
      '<button class="fpq__btn fpq__btn--atc" data-atc><span data-btn-price>' + money(pr.total) + '</span><span>&ndash;</span><span>Add to cart</span></button>' +
      unlockBtn() + '</div>';
    html += unlockPanel();
    html += '<p class="fpq__buysub" data-buysub>' + (fam === 'fireoven' ? 'Pre-order. September delivery. ' : '') + '30-day money back. ' + (state.unlocked ? 'Free shipping applied (' + (S.discountCode || 'QUIZSHIP') + ').' : '') + ' <a href="' + esc(pan.url) + '" data-pdp-link>Read the full story</a>.</p>';

    /* Trust row (guarantee switches with material) */
    var guarantee = fam === 'seasoned' || fam === 'fireoven' ? 'Three Generation Guarantee&reg;' : 'Lifetime Guarantee';
    var third = fam === 'fireoven' ? '1,500 exist, individually numbered' : 'Hand-poured, recycled iron';
    html += '<div class="fpq__trust"><div>30-day<br>money back</div><div data-guarantee>' + guarantee + '</div><div>' + third + '</div></div>';

    if (r.soldout) html += '<div class="fpq__block"><p>All 1,500 Fire Oven Sets are spoken for. When a design sells out it is gone for good. For the fire cook, the Grande Legacy is the pan that lives outdoors.</p></div>';

    /* Sales letter blocks */
    var solutionLine = (fam === 'seasoned' || fam === 'fireoven') ? COPY.solution.seasoned : COPY.solution.enamel;
    html += '<div class="fpq__block"><h2>It was never your fault.</h2><p>' + esc(COPY.sting[a.sting] || COPY.sting.rebuy) + '</p>' +
      '<p>' + esc(solutionLine) + '</p></div>';
    var chef = COPY.chef[a.chef] || COPY.chef.heritage;
    html += '<div class="fpq__block"><p class="fpq__quote">&ldquo;' + esc(chef.q) + '&rdquo;<span class="fpq__quote-cite">' + esc(chef.c) + '</span></p></div>';
    var revs = COPY.reviews[fam];
    if (revs) {
      html += '<div class="fpq__block"><h2>From people who own one</h2>' + revs.map(function (rv) {
        return '<p class="fpq__quote" style="font-size:16px">&ldquo;' + esc(rv.q) + '&rdquo;<span class="fpq__quote-cite">' + esc(rv.c) + '</span></p>';
      }).join('') + '</div>';
    }
    html += '<div class="fpq__block"><h2>The honest questions</h2>' + COPY.objections[objKey].map(function (o) {
      return '<details class="fpq__obj"><summary>' + esc(o.q) + '</summary><p>' + esc(o.a) + '</p></details>';
    }).join('') + '</div>';
    html += '<div class="fpq__block"><p>' + esc(COPY.close) + '</p><p class="fpq__mono" style="margin-top:18px">' + esc(COPY.signoff) + '<br>Ironclad Co.</p></div>';
    html += '</div>';

    /* Sticky mobile bar */
    html += '<div class="fpq__sticky" data-sticky><button class="fpq__btn" data-atc-sticky><span data-btn-price-sticky>' + money(pr.total) + '</span><span>&ndash;</span><span>Add to cart</span></button></div>';

    app.innerHTML = html;
    root.classList.add('fpq--results');
    bindResults(app, fam);
    if (!state._resultTracked) {
      state._resultTracked = true;
      track('foreverpan_result_viewed', { quiz_result: resultKey(), quiz_archetype: r.arch, gated: false });
      fb('QuizComplete', { quiz_result: resultKey() }, true);
    }
    announce('Your result: ' + arch.name + '. ' + pan.title);
  }

  function bundleCard(b, selected) {
    return '<button class="fpq__bundle' + (selected ? ' is-selected' : '') + '" data-mode="' + esc(b.key) + '">' +
      (b.img ? '<img src="' + esc(b.img) + '" alt="">' : '') +
      '<span><span class="fpq__bundle-name">' + esc(b.name) + '</span>' + (b.sub ? '<br><span class="fpq__bundle-sub">' + esc(b.sub) + '</span>' : '') + '</span>' +
      (b.save ? '<span class="fpq__save">Save ' + money(b.save).replace(' NZD', '') + '</span>' : '') + '</button>';
  }
  function unlockBtn() {
    return '<button class="fpq__btn fpq__btn--outline fpq__btn--ship' + (state.unlocked ? ' is-done' : '') + '" data-unlock-toggle>' + (state.unlocked ? COPY.unlock.doneBtn : COPY.unlock.btn) + '</button>';
  }
  function unlockPanel() {
    if (state.unlocked) {
      return '<div class="fpq__unlock is-open"><span class="fpq__code">' + esc(S.discountCode || 'QUIZSHIP') + '</span><p style="margin-top:10px">' + COPY.unlock.doneP + '</p></div>';
    }
    return '<div class="fpq__unlock" data-unlock-panel><p>' + COPY.unlock.openP + '</p>' +
      '<div class="fpq__unlock-row"><input type="email" placeholder="Email address" autocomplete="email" aria-label="Email address"><button class="fpq__btn" data-unlock-submit>' + COPY.unlock.submit + '</button></div>' +
      '<p class="fpq__error" hidden data-unlock-error>That email doesn’t look right.</p>' +
      '<p class="fpq__unlock-fine">' + COPY.unlock.fine + '</p></div>';
  }
  function playbackLine(a) {
    var forks = { one: 'cooking for one', two: 'cooking for two', three_four: 'cooking for three or four', mob: 'feeding the mob' };
    var stove = { gas: 'on gas', induction: 'on induction', electric: 'on electric', live_fire: 'over fire', pizza_oven: 'in the pizza oven' };
    var want = { heirloom: 'you want the pan your kids argue over', table: 'you want it to look right on the table', capacity: 'you want everyone fed in one go', fire: 'you want it to handle proper fire' };
    var line = (forks[state.raw.household] || 'cooking for your table') + ' ' + (stove[a.use_case] || '') + ', and ' + (want[a.priority] || 'you want a pan for life') + '.';
    line = line.replace(/\s+/g, ' ').trim();
    return line.charAt(0).toUpperCase() + line.slice(1);
  }
  function sizeHint(a, r) {
    var m = { '1-2': 'Matched to a one-or-two-fork table', '3-4': 'Matched to your three-or-four-fork table', '5plus': 'Matched to the mob' };
    return m[a.household] || 'Matched to how you cook';
  }
  function articleFor(n) { return /^The [AEIOU]/i.test(n) ? 'an' : 'a'; }

  function bindResults(app, fam) {
    var rerender = function () { renderResults(app); };
    app.querySelectorAll('[data-size]').forEach(function (b) {
      b.addEventListener('click', function () { state.res.size = +b.getAttribute('data-size'); rerender(); });
    });
    app.querySelectorAll('[data-colour]').forEach(function (b) {
      b.addEventListener('click', function () { state.colour = b.getAttribute('data-colour'); rerender(); });
    });
    app.querySelectorAll('[data-mode]').forEach(function (b) {
      b.addEventListener('click', function () { state.mode = b.getAttribute('data-mode'); rerender(); });
    });
    app.querySelectorAll('.fpq__addon').forEach(function (row) {
      var key = row.getAttribute('data-addon');
      row.querySelector('input').addEventListener('change', function (e) {
        state.addons[key] = e.target.checked;
        track('foreverpan_bump_toggle', { bump_handle: key, checked: e.target.checked });
        rerender();
      });
      row.querySelector('.fpq__addon-toggle').addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        row.classList.toggle('is-open');
        this.setAttribute('aria-expanded', row.classList.contains('is-open'));
      });
    });
    var goCheckout = function () {
      var sel = currentSelection(); var pr = priceOf(sel);
      track('foreverpan_checkout_click', { quiz_result: resultKey(), quiz_archetype: state.res.arch, total: pr.total, items: pr.items.length, discount_applied: state.unlocked });
      window.location.href = permalink(sel);
    };
    var atc = app.querySelector('[data-atc]'); if (atc) atc.addEventListener('click', goCheckout);
    var atcS = app.querySelector('[data-atc-sticky]'); if (atcS) atcS.addEventListener('click', goCheckout);
    var fo = app.querySelector('[data-fireoven-cta]'); if (fo) fo.addEventListener('click', function () {
      track('foreverpan_checkout_click', { quiz_result: 'lennox_fos', quiz_archetype: 'fire_cook', total: null, discount_applied: false });
    });
    var toggle = app.querySelector('[data-unlock-toggle]');
    if (toggle && !state.unlocked) toggle.addEventListener('click', function () {
      var panel = app.querySelector('[data-unlock-panel]');
      panel.classList.toggle('is-open');
      if (panel.classList.contains('is-open')) {
        track('foreverpan_unlock_viewed', { quiz_result: resultKey() });
        panel.querySelector('input').focus();
      }
    });
    var submit = app.querySelector('[data-unlock-submit]');
    if (submit) submit.addEventListener('click', function () {
      var input = app.querySelector('[data-unlock-panel] input');
      var err = app.querySelector('[data-unlock-error]');
      var email = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.hidden = false; input.focus(); return; }
      err.hidden = true;
      state.unlocked = true; state.email = email;
      klaviyoIdentifyAndTrack(email);
      fb('Lead', { quiz_result: resultKey(), quiz_archetype: state.res.arch, content_name: 'forever_pan_quiz' });
      track('foreverpan_lead', { quiz_result: resultKey(), quiz_archetype: state.res.arch });
      renderResults(app);
    });
    /* Sticky bar visibility */
    var buyrow = app.querySelector('.fpq__buyrow'); var sticky = app.querySelector('[data-sticky]');
    if (buyrow && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(buyrow);
    }
  }

  render();
})();